import { render } from "./PropertyDetails.vue?vue&type=template&id=369d9aa1&scoped=true&ts=true"
import script from "./PropertyDetails.vue?vue&type=script&lang=ts"
export * from "./PropertyDetails.vue?vue&type=script&lang=ts"

import "./PropertyDetails.vue?vue&type=style&index=0&id=369d9aa1&scoped=true&lang=scss"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-369d9aa1"]])

export default __exports__